import React from "react";
import "react-dropdown-tree-select/dist/styles.css";
import { useInterviewContext } from "../../InterviewContext";
import "../../../styles/mobilitySelect.scss";
import { useTranslation } from "react-i18next";

const Mobility = ({ interview }) => {
  const selectedMobility = interview.availabilityAndConditions.mobility || [];
  const { t } = useTranslation();

  const mobilityAreas = selectedMobility.reduce((acc, currentMobility) => {
    if (currentMobility.checked === true) {
      acc.push(<div className="areas">{currentMobility.label}</div>);
    }
    currentMobility.children.forEach((element) => {
      if (element.checked === true) {
        acc.push(<div className="areas">{element.label}</div>);
      }
    });
    return acc;
  }, []);

  return (
    <div className="mobility">
      <h1>{t("Mobility*")}</h1>
      <div className="selected-areas">
        {mobilityAreas.length > 0 ? (
          mobilityAreas
        ) : (
          <div>
            {t("There is no mobility area selected for this interview.")}
          </div>
        )}
      </div>
    </div>
  );
};

export default Mobility;
